export default __webpack_public_path__ + "static/media/bodyandspiritwrack4.45abc3d9.png";